import React from 'react';

import { ButtonProps } from 'primereact/button';

import { NewStyledButton } from './styled';

export const NewPrimeButton = (props: ButtonProps) => {
  return <NewStyledButton {...props} />;
};
